module.exports = __webpack_public_path__ + "img/gys_20@2x.f50bb14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_20@2x.png
// module id = FXcr
// module chunks = 0